"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));
var _RentalPackage = _interopRequireDefault(require("../model/RentalPackage"));
var _RentalPackageCreate = _interopRequireDefault(require("../model/RentalPackageCreate"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
* RentalPackages service.
* @module api/RentalPackagesApi
* @version 0.0.1
*/
class RentalPackagesApi {
  /**
  * Constructs a new RentalPackagesApi. 
  * @alias module:api/RentalPackagesApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  constructor(apiClient) {
    this.apiClient = apiClient || _ApiClient.default.instance;
  }

  /**
   * Callback function to receive the result of the createRentalPackagePackagePost operation.
   * @callback module:api/RentalPackagesApi~createRentalPackagePackagePostCallback
   * @param {String} error Error message, if any.
   * @param {module:model/RentalPackage} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Create Rental Package
   * @param {module:model/RentalPackageCreate} rentalPackageCreate 
   * @param {module:api/RentalPackagesApi~createRentalPackagePackagePostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/RentalPackage}
   */
  createRentalPackagePackagePost(rentalPackageCreate, callback) {
    let postBody = rentalPackageCreate;
    // verify the required parameter 'rentalPackageCreate' is set
    if (rentalPackageCreate === undefined || rentalPackageCreate === null) {
      throw new Error("Missing the required parameter 'rentalPackageCreate' when calling createRentalPackagePackagePost");
    }
    let pathParams = {};
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _RentalPackage.default;
    return this.apiClient.callApi('/package/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the deleteRentalPackagePackagePackageIdDelete operation.
   * @callback module:api/RentalPackagesApi~deleteRentalPackagePackagePackageIdDeleteCallback
   * @param {String} error Error message, if any.
   * @param {Object} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Delete Rental Package
   * @param {Number} packageId 
   * @param {module:api/RentalPackagesApi~deleteRentalPackagePackagePackageIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Object}
   */
  deleteRentalPackagePackagePackageIdDelete(packageId, callback) {
    let postBody = null;
    // verify the required parameter 'packageId' is set
    if (packageId === undefined || packageId === null) {
      throw new Error("Missing the required parameter 'packageId' when calling deleteRentalPackagePackagePackageIdDelete");
    }
    let pathParams = {
      'package_id': packageId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = Object;
    return this.apiClient.callApi('/package/{package_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the getRentalPackagePackagePackageIdGet operation.
   * @callback module:api/RentalPackagesApi~getRentalPackagePackagePackageIdGetCallback
   * @param {String} error Error message, if any.
   * @param {module:model/RentalPackage} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get Rental Package
   * @param {Number} packageId 
   * @param {module:api/RentalPackagesApi~getRentalPackagePackagePackageIdGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/RentalPackage}
   */
  getRentalPackagePackagePackageIdGet(packageId, callback) {
    let postBody = null;
    // verify the required parameter 'packageId' is set
    if (packageId === undefined || packageId === null) {
      throw new Error("Missing the required parameter 'packageId' when calling getRentalPackagePackagePackageIdGet");
    }
    let pathParams = {
      'package_id': packageId
    };
    let queryParams = {};
    let headerParams = {};
    let formParams = {};
    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = _RentalPackage.default;
    return this.apiClient.callApi('/package/{package_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the getRentalPackagesPackageGet operation.
   * @callback module:api/RentalPackagesApi~getRentalPackagesPackageGetCallback
   * @param {String} error Error message, if any.
   * @param {Array.<module:model/RentalPackage>} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Get Rental Packages
   * @param {Object} opts Optional parameters
   * @param {Date} [start] 
   * @param {Date} [end] 
   * @param {module:api/RentalPackagesApi~getRentalPackagesPackageGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link Array.<module:model/RentalPackage>}
   */
  getRentalPackagesPackageGet(opts, callback) {
    opts = opts || {};
    let postBody = null;
    let pathParams = {};
    let queryParams = {
      'start': opts['start'],
      'end': opts['end']
    };
    let headerParams = {};
    let formParams = {};
    let authNames = [];
    let contentTypes = [];
    let accepts = ['application/json'];
    let returnType = [_RentalPackage.default];
    return this.apiClient.callApi('/package/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }

  /**
   * Callback function to receive the result of the updateRentalPackagePackagePut operation.
   * @callback module:api/RentalPackagesApi~updateRentalPackagePackagePutCallback
   * @param {String} error Error message, if any.
   * @param {module:model/RentalPackage} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Update Rental Package
   * @param {Number} packageId 
   * @param {module:model/RentalPackageCreate} rentalPackageCreate 
   * @param {module:api/RentalPackagesApi~updateRentalPackagePackagePutCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/RentalPackage}
   */
  updateRentalPackagePackagePut(packageId, rentalPackageCreate, callback) {
    let postBody = rentalPackageCreate;
    // verify the required parameter 'packageId' is set
    if (packageId === undefined || packageId === null) {
      throw new Error("Missing the required parameter 'packageId' when calling updateRentalPackagePackagePut");
    }
    // verify the required parameter 'rentalPackageCreate' is set
    if (rentalPackageCreate === undefined || rentalPackageCreate === null) {
      throw new Error("Missing the required parameter 'rentalPackageCreate' when calling updateRentalPackagePackagePut");
    }
    let pathParams = {};
    let queryParams = {
      'package_id': packageId
    };
    let headerParams = {};
    let formParams = {};
    let authNames = ['JWTBearer'];
    let contentTypes = ['application/json'];
    let accepts = ['application/json'];
    let returnType = _RentalPackage.default;
    return this.apiClient.callApi('/package', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
  }
}
exports.default = RentalPackagesApi;